import React, { useContext, useState } from "react";
import styled from "styled-components";

import Button from "../common/Button";
import { ExamContext, ExamState } from "../exam/context/examContext";

import Modal from "./Modal";

//todo: swap these to common-ui
const PrimaryButton = styled(Button)`
  background-color: #006699;
  color: white;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;

  &:hover {
    background-color: #0170a7;
  }
`;
const SecondaryButton = styled(Button)`
  background-color: #e7e7e7;
  color: #333;
  display: flex;
  align-items: center;
  font-weight: bold;
  text-transform: uppercase;
  height: 4rem;
  transform: background-color 0.2s;

  &:hover {
    background-color: #e0e0e0;
  }
`;

type SubmitModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isForced: boolean;

  onSubmit?: (state: ExamState) => Promise<void>;
};
export const SubmitModal = (props: SubmitModalProps) => {
  const [state, dispatch] = useContext(ExamContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Modal
      title={props.isForced ? "Submit Exam" : "Ready to Submit?"}
      isOpen={props.isOpen}
      onRequestClose={() => props.setIsOpen(false)}
      hideCloseButton={props.isForced}
      buttons={
        <div style={{ display: "flex", gap: "1rem" }}>
          {!isSubmitting && !props.isForced && (
            <SecondaryButton onClick={() => props.setIsOpen(false)}>
              Cancel
            </SecondaryButton>
          )}
          <PrimaryButton
            disabled={isSubmitting}
            data-cy="submit-button"
            onClick={async () => {
              setIsSubmitting(true);

              await props.onSubmit?.(state);

              setIsSubmitting(false);
              props.setIsOpen(false);
              dispatch({
                type: "COMPLETE",
              });
            }}
          >
            {isSubmitting ? "Please Wait..." : "Submit"}
          </PrimaryButton>
        </div>
      }
    >
      <div style={{ padding: "1rem 1rem" }}>
        {props.isForced
          ? "It’s time to submit your activity."
          : "Are you ready to submit your activity?"}
      </div>
    </Modal>
  );
};
